import { CardRating } from '@curology/ui-components-web/react/Card/CardRating';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

export const ModalRatingAndNumReviews = ({
  modalCard: { rating, numReviews },
}: {
  modalCard: Card;
}) => {
  if (!rating || !numReviews) {
    return null;
  }

  return (
    <>
      <div className="cur-mt-4">
        <CardRating
          className="cur-inline-flex"
          count={numReviews}
          size="sm"
          value={rating}
        />
        <sup>*</sup>
      </div>
      <Typography>
        *Ratings are averaged from Target.com and our e-commerce shop on
        2/21/2023.
      </Typography>
    </>
  );
};
